var ppPay = require('./main.js')
ppPay.version = require('./version').v
module.exports = ppPay